module.exports = __webpack_public_path__ + "img/aba.44b11f5c.jpg";